<template>
  <app-layout>
    <template #main-content>
      <main id="content" class="l-main p-learning">
        <div class="l-main__inner">
          <!--header section-->
          <div class="c-page-header">
            <h1 class="c-page-header-title">学習状況</h1>
          </div>
          <!--Summary-->
          <div class="p-learning-block" v-show="loading">
            <ul class="p-learning-status">
              <li>
                <div class="p-learning-status-content">
                  <div class="p-learning-status-content__header">
                    <p class="heading">
                      <span class="c-icon -calendar"></span>
                      <span class="label">累計学習日</span>
                    </p>
                  </div>
                  <div class="p-learning-status-content__body">
                    <div class="p-learning-status-content__body__cumulative">
                      <div class="textNum"><span class="num">{{totalStudyDays}}</span>日</div>
                      <p class="textSupplement">(連続学習 <span class="num">{{consecutiveStudyDays}}</span>日)</p>
                    </div>
                    <div class="p-learning-status-content__body__monthly">
                      <p class="textAchievement">今月：<span class="num">{{monthlyStudyDays}}</span>日</p>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div class="p-learning-status-content">
                  <div class="p-learning-status-content__header">
                    <p class="heading">
                      <span class="c-icon -clock"></span>
                      <span class="label">累計学習時間</span>
                    </p>
                  </div>
                  <div class="p-learning-status-content__body">
                    <div class="p-learning-status-content__body__cumulative">
                      <div class="textNum"><span class="num">{{totalStudyHours}}</span>時間</div>
                      <p class="textSupplement">（連続学習 <span class="num">{{consecutiveStudyHours}}</span>時間）</p>
                    </div>
                    <div class="p-learning-status-content__body__monthly">
                      <p class="textAchievement">今月：<span class="num">{{monthlyStudyHours}}</span>時間<span class="num">{{monthlyStudyMinutes}}</span>分</p>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div class="p-learning-status-content">
                  <div class="p-learning-status-content__header">
                    <p class="heading">
                      <span class="c-icon -star"></span>
                      <span class="label">累計獲得スター</span>
                    </p>
                  </div>
                  <div class="p-learning-status-content__body">
                    <div class="p-learning-status-content__body__cumulative">
                      <div class="textNum"><span class="num">{{totalNumOfStars}}</span>個</div>
                    </div>
                    <div class="p-learning-status-content__body__monthly">
                      <p class="textAchievement">今月：<span class="num">{{monthlyNumOfStars}}</span>個</p>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div class="p-learning-status-content">
                  <div class="p-learning-status-content__header">
                    <p class="heading">
                      <span class="c-icon -flag"></span>
                      <span class="label">累計クリア<br>ミッション</span>
                    </p>
                  </div>
                  <div class="p-learning-status-content__body">
                    <div class="p-learning-status-content__body__cumulative">
                      <div class="textNum"><span class="num">{{totalClearedMissions}}</span>回</div>
                    </div>
                    <div class="p-learning-status-content__body__monthly">
                      <p class="textAchievement">今月：<span class="num">{{monthlyClearedMissions}}</span>回</p>
                    </div>
                  </div>
                </div>
              </li>
              <li v-if="hidden">
                <div class="p-learning-status-content">
                  <div class="p-learning-status-content__header">
                    <p class="heading">
                      <span class="c-icon -badge"></span>
                      <span class="label">獲得バッジ</span>
                    </p>
                  </div>
                  <div class="p-learning-status-content__body">
                    <div class="p-learning-status-content__body__cumulative">
                      <div class="textNum"><span class="num">12</span><span class="num num--parameter">/164</span>個</div>
                    </div>
                    <div class="p-learning-status-content__body__monthly">
                      <p class="textAchievement">今月：<span class="num">2</span>個</p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <!--disabled-->
            <div class="p-learning-block__button">
              <button-arrow-right :to="{name:'learning-status-detail', params:{}}" name="S5-1-learning-detail-btn">
                これまでの学習状況を見る
              </button-arrow-right>
            </div>
          </div>
          <div class="p-learning-block -calendar" v-show="loading">
            <div class="c-calendar">
              <div class="c-calendar__header">
                <div class="columnNav columnNav--prev">
                  <a href="javascript:void(0)"
                      name="S5-1-prev-month-btn"
                     :class="{'c-button-white -prev':true,'-disabled': !isPrevMonth()}" @click="backPrevMonth()">
                    <span class="label">
                      <span class="halfsize">{{previousMonth()}}</span>月
                    </span>
                  </a>
                </div>
                <div class="columnCaption">
                  <div class="textCaption"><span class="halfsize">{{selectedYear}}</span>年 <span class="halfsize">{{selectedMonth}}</span>月</div>
                  <div class="listLegend">
                    <p class="listLegend__inner">
                      <span class="c-icon -star"></span>獲得スター<br>
                      <span class="c-icon -flag"></span>クリアミッション
                    </p>
                  </div>
                </div>
                <div class="columnNav columnNav--next">
                  <a href="javascript:void(0)"
                      name="S5-1-next-month-btn"
                     :class="{'c-button-white -next':true,'-disabled': !isNextMonth()}" @click="goNextMonth()">
                    <span class="label">
                      <span class="halfsize">{{nextMonth()}}</span>月
                    </span>
                  </a>
                </div>
              </div>
              <div class="c-calendar__table">
                <table>
                  <thead>
                    <tr>
                      <th>月</th>
                      <th>火</th>
                      <th>水</th>
                      <th>木</th>
                      <th>金</th>
                      <th class="sat">土</th>
                      <th class="sun">日</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="weekly in monthly_summary">
                      <template v-for="(daily, index) in weekly">
                        <td class="disabled" v-if="daily.is_current_month===false"
                            :class="{
                              'sunday': index===6 || daily.is_holiday,
                              'today': daily.day===today.getDate()
                                       && daily.month === today.getMonth()+1
                                       && daily.year === today.getFullYear()
                            }"
                        >
                          <div class="cellInner" @click="popupBalloonString=''" name="S5-1-balloon-btn">
                            <div class="date"><span class="num">{{daily.day}}</span></div>
                          </div>
                        </td>

                        <td v-else
                            :class="{
                              'sunday': index===6 || daily.is_holiday,
                              'today': daily.day===today.getDate()
                                       && daily.month === today.getMonth()+1
                                       && daily.year === today.getFullYear()
                            }"
                        >
                          <div class="cellInner"
                               :class="{'jsBalloonTrig': daily.study_minutes.total>0}"
                               name="S5-1-balloon-btn"
                               @click="openPopupBalloon(daily)"
                          >
                            <div class="date">
                              <span class="num">{{daily.day}}</span>
                              <popup-balloon
                                v-if="popupBalloonString ===`${daily.year}-${daily.month}-${daily.day}`"
                                :year="daily.year"
                                :month="daily.month"
                                :day="daily.day"
                                :is-left="index>=3"
                                :is-popup-balloon="daily.study_minutes.total>0"
                                :data-pie-value="makeDataPieValue(daily.study_minutes)"
                                :licensed-subject="licensedSubjects(daily.study_minutes)">
                              </popup-balloon>
                            </div>
                            <div class="params">
                              <div class="modTask modTask--exam" v-if="hidden"><span class="label">中間テスト</span></div>
                              <ul class="listStatus">
                                <li>
                                  <div class="listStatusBlock" v-if="daily.number_of_stars>0">
                                    <div class="icon">
                                      <div class="c-icon -star"><span class="c-parts-badge">{{daily.number_of_stars}}</span></div>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div class="listStatusBlock" v-if="daily.cleared_missions">
                                    <div class="icon">
                                      <div class="c-icon -flag"><span class="c-parts-badge">{{daily.cleared_missions}}</span></div>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                              <div class="c-calendar-task c-calendar-task--history" v-if="daily.study_minutes.total">
                                <span class="label"><span class="halfsize">{{daily.study_minutes.total}}</span>分</span>
                              </div>
                            </div>
                          </div>
                        </td>
                      </template>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <section class="p-learning-block" v-show="hidden && loading">
            <h2 class="c-page-header-subtitle"><span class="halfsize">{{selectedMonth}}</span>月に獲得したバッジ</h2>

            <div class="c-slide" id="badge_slide">
              <div class="c-slide__navBg">
                <div class="circle circle--prev">
                </div>
                <div class="circle circle--next">
                </div>
              </div>
              <div class="c-slide__body">
                <div class="c-slide__body__inner">
                  <div class="p-learning-badge-container">
                    <div class="p-learning-badge-container__inner">
                      <carousel :swiper-id-badge="swiperIdBadge">
                        <li v-for="n of 15" class="swiper-slide">
                          <div class="p-learning-badge-block">
                            <img src="../../styles/img/dummy/img_thumb_badge.png" alt="バッジ名">
                          </div>
                        </li>
                      </carousel>
                    </div>
                  </div>
                </div>
              </div>
              <div class="c-slide__navButton">
                <div class="btn btn--prev">
                </div>
                <div class="btn btn--next">
                </div>
              </div>
            </div>
            <div class="p-learning-block__button">
              <button-arrow-right :to="{name:'', params:{}}">
                獲得バッジをすべて見る
              </button-arrow-right>
            </div>
          </section>
        </div>
      </main>
    </template>
  </app-layout>
</template>

<script setup lang="ts">
  import {ref,onMounted, onUnmounted, computed} from "vue";
  import Swiper, {Navigation, Pagination} from "swiper";
  import {SUBJECT_MAP} from "@/consts/subject";
  import {ITotalSummary, ICalendarRange, IDaily} from "@/consts/interfaces";
  import { useGlobalNavigationStore } from '@/store/student/global_navigation_store';
  import { useWorkStore } from '@/store/student/work_store';
  import { useLearningStatusStore } from '@/store/student/learning_status_store';

  Swiper.use([Navigation, Pagination]);

  const globalNavigationStore = useGlobalNavigationStore()
  const workStore = useWorkStore()
  const learningStatusStore = useLearningStatusStore()
  const loading = ref(false);
  const hidden = ref(false);
  const today = ref(new Date());
  const selectedYear = ref(new Date().getFullYear());
  const selectedMonth = ref(new Date().getMonth() + 1);
  const swiperIdBadge = ref("swiper_badge")
  const popupBalloonString = ref("")
  const subject_sort_order = ref(['国語', '社会', '数学', '理科', '英語'])
  const processing = ref(false)
  const total_summary = ref<ITotalSummary>({
    total_study_days: 0,
    consecutive_study_days: 0,
    monthly_study_days: 0,
    total_study_hours: 0,
    consecutive_study_hours: 0,
    monthly_study_minutes: 0,
    total_number_of_stars: 0,
    monthly_number_of_stars: 0,
    total_cleared_missions: 0,
    monthly_cleared_missions: 0
  })
  const calendar_range = ref<ICalendarRange>({
    lower: {
      year: null,
      month: null,
    },
    upper: {
      year: null,
      month: null
    }
  })
  const monthly_summary = ref<Array<Array<IDaily>>>([])

  onMounted(async() => {
    globalNavigationStore.saveSelectedMenu('star')
    document.title = "学習状況 - MANAVIRIA"
    total_summary.value = await learningStatusStore.fetchTotalSummary()
    calendar_range.value = await learningStatusStore.fetchCalendarRange()
    monthly_summary.value = await learningStatusStore.fetchMonthlySummary({year: selectedYear.value, month: selectedMonth.value})
    loading.value = true
    const swiperBadgeOption = {
      loop: true,
      speed: 500,
      slidesPerView: 1,
      spaceBetween: 25,
      loopAdditionalSlides: 20,
      navigation: {
        nextEl: '#badge_slide .modSlideBox__navButton .btn--next',
        prevEl: '#badge_slide .modSlideBox__navButton .btn--prev'
      }
    }

    if (swiperIdBadge.value) {
      let swiper_obj = document.getElementById(swiperIdBadge.value);
      if (swiper_obj) {
        if (swiper_obj.getElementsByClassName("swiper-slide").length > 1) {
          new Swiper("#" + swiperIdBadge.value, swiperBadgeOption)
        }
      }
    }
    window.addEventListener('popstate', browserBackHandler);
  })
  function browserBackHandler(){
    // make selectedWork empty avoid flicking work page
    workStore.saveSelectedWork([])
    window.location.reload()
  }
  const totalStudyDays = computed(() => {
    return total_summary.value.total_study_days
  })
  const consecutiveStudyDays = computed(() => {
    return total_summary.value.consecutive_study_days
  })
  const monthlyStudyDays = computed(() => {
    return total_summary.value.monthly_study_days
  })
  const totalStudyHours = computed(() => {
    return total_summary.value.total_study_hours
  })
  const consecutiveStudyHours = computed(() => {
    return total_summary.value.consecutive_study_hours
  })
  const monthlyStudyHours = computed(() => {
    return Math.floor(total_summary.value.monthly_study_minutes/60)
  })
  const monthlyStudyMinutes = computed(() => {
    return total_summary.value.monthly_study_minutes % 60
  })
  const totalNumOfStars = computed(() => {
    return total_summary.value.total_number_of_stars
  })
  const monthlyNumOfStars = computed(() => {
    return total_summary.value.monthly_number_of_stars
  })
  const totalClearedMissions = computed(() => {
    return total_summary.value.total_cleared_missions
  })
  const monthlyClearedMissions = computed(() => {
    return total_summary.value.monthly_cleared_missions
  })
  function isPrevMonth(){
    return calendar_range.value.lower.year < selectedYear.value
      || calendar_range.value.lower.month <= (selectedMonth.value-1);
  }
  function isNextMonth(){
    return selectedYear.value < calendar_range.value.upper.year
      || (selectedMonth.value+1) <= calendar_range.value.upper.month;

  }
  function previousMonth(){
    if(selectedMonth.value==1){
      return "12"
    }else{
      return selectedMonth.value - 1
    }
  }
  function nextMonth(){
    if(selectedMonth.value==12){
      return "1"
    }
    else{
      return selectedMonth.value + 1
    }
  }
  async function backPrevMonth(){
    popupBalloonString.value = ""
    if(processing.value == true){
      return
    }
    processing.value = true
    if(selectedMonth.value==1){
      selectedYear.value -= 1
      selectedMonth.value = 12
    }else{
      selectedMonth.value -= 1
    }
    monthly_summary.value = await learningStatusStore.fetchMonthlySummary({year: selectedYear.value, month: selectedMonth.value})
    processing.value = false
  }
  async function goNextMonth(){
    popupBalloonString.value = ""
    if(processing.value == true){
      return
    }
    processing.value = true
    if(selectedMonth.value==12){
      selectedYear.value += 1
      selectedMonth.value = 1
    }else{
      selectedMonth.value += 1
    }
    monthly_summary.value = await learningStatusStore.fetchMonthlySummary({year: selectedYear.value, month: selectedMonth.value})
    processing.value = false
  }
  function licensedSubjects(study_time: {[id: string]: number}){
    let subject: Array<any> = []
    for(let name of subject_sort_order.value){
      if(study_time[name]!=0){
        subject.push({name:name, value: SUBJECT_MAP[name]})
      }
    }
    return subject
  }
  function makeDataPieValue(study_time: {[id: string]: number}){
    let times: Array<number> = [];
    for(let name of subject_sort_order.value){
      if(study_time[name]!=0){
        times.push(study_time[name])
      }
    }
    return times
  }
  function openPopupBalloon(daily: IDaily){
    const popupBalloonLocal: string = `${daily.year}-${daily.month}-${daily.day}`
    if(popupBalloonString.value == popupBalloonLocal){
      popupBalloonString.value = ""
    }else{
      popupBalloonString.value = popupBalloonLocal
    }
  }
  onUnmounted(() => {
    window.removeEventListener('popstate', browserBackHandler);
  })
</script>
